import { Component, ojs, app } from "modular-openscriptjs";
import { dom } from "../../fotastart";
import { routes } from "../../backendRoutes";

// Components
import CommentView from "./CommentView";
import { empty, eParse } from "../../helpers";

const h = app("h");
const api = app("api");
const route = app("router");

ojs(CommentView);

export default class CommentRepliesView extends Component {
	render(comment, ...args) {
		return h.div(
			{
				$sp_comment_children_for: `c-${comment.id}`,
				$class: "d-block w-100",
				$sp_comment_page: 0,
			},
			h.div({
				sp_cc_hook: `comment-holder-${comment.id}`,
				class: "d-flex flex-column gap-2",
			}),
			h.div(
				{
					sp_cc_hook: `load-more-${comment.id}`,
					class: "bg-white border text-secondary border-light-subtle dropdown-toggle fw-bold mb-1 p-2 rounded-3 text-center fs-xsm cursor-pointer d-none",
					onclick: this.method("getReplies", comment),
				},
				"Load More Replies"
			),
			...args
		);
	}

	async getReplies(comment) {
		let parent = dom.get(`[sp-comment-children-for="c-${comment.id}"]`);
		if (!parent) return;

		let page = Number(parent.getAttribute("sp-comment-page") || 0);

		let holder = dom.get(
			`[sp-cc-hook="comment-holder-${comment.id}"]`,
			parent
		);

		let loadMore = dom.get(
			`[sp-cc-hook="load-more-${comment.id}"]`,
			parent
		);

		loadMore?.classList.add("d-none");

		let spinner = h.Spinner({
			class: "bg-transparent p-2",
			sp_spinner: true,
			parent: holder,
		});

		let res = await api.get(`${routes.comments}/${comment.id}/replies`, {
			page: page + 1,
		});

		if (res) {
			let comments = res.data.comments.data;

			for (let comment of comments) {
				let id = `c-${comment.id}`;
				let rendered = false;

				if (dom.get(`[sp-comment-id="${id}"]`, holder)) {
					rendered = true;
				}

				if (!rendered) {
					h.CommentView(comment, {
						class: "bg-white rounded-3 p-3 border border-light-subtle shadow-sm",
						parent: holder,
						$sp_comment_id: id,
					});

					h.CommentRepliesView(comment, {
						$class: "d-none ps-3", // Indent nested replies
						parent: holder,
						$sp_comment_replies_holder: `c-${comment.id}`,
					});
				}
			}

			if (!empty(comments)) {
				page = res.data.comments.current_page;
			}

			if (res.data.comments.last_page > page) {
				loadMore?.classList.remove("d-none");
			}
		}

		spinner.remove();
		parent.setAttribute("sp-comment-page", page);
	}

	updateRepliesList(ed, event) {
		if (!route.is("product.view-product")) return;
		let { comment } = eParse(ed).message;

		let parent = dom.get(`[sp-comment-children-for="c-${comment.id}"]`);
		if (!parent) return;

		let holder = dom.get(
			`[sp-cc-hook="comment-holder-${comment.id}"]`,
			parent
		);
		let { reply } = eParse(ed).message;

		comment = reply;
		let id = `c-${comment.id}`;

		h.CommentRepliesView(comment, {
			$class: "d-none ps-3",
			parent: holder,
			firstOfParent: true,
			$sp_comment_replies_holder: `c-${comment.id}`,
		});

		h.CommentView(comment, {
			class: "bg-white rounded-3 p-3 border border-light-subtle shadow-sm",
			parent: holder,
			firstOfParent: true,
			$sp_comment_id: id,
		});
	}

	$$comment = {
		is: {
			repliedTo: (ed, event) => this.updateRepliesList(ed, event),
		},
		needs: {
			replies: (ed, event) => {
				let { comment } = eParse(ed).message;
				this.getReplies(comment);
			},
		},
	};
}

ojs(CommentRepliesView);
